module.exports = __webpack_public_path__ + "static/media/S1_00021.240dac23.jpg";